import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconTrendingDown = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.3332 17H15.3332C14.781 17 14.3332 16.5523 14.3332 16C14.3332 15.4477 14.781 15 15.3332 15H16.919L12.9999 11.0809L10.3737 13.7071C10.1861 13.8946 9.9318 14 9.66658 14C9.40136 14 9.14701 13.8946 8.95947 13.7071L3.95947 8.70711C3.56895 8.31658 3.56895 7.68342 3.95947 7.29289C4.35 6.90237 4.98316 6.90237 5.37369 7.29289L9.66658 11.5858L12.2928 8.95956C12.4803 8.77202 12.7347 8.66667 12.9999 8.66667C13.2651 8.66667 13.5195 8.77202 13.707 8.95956L18.3332 13.5858V12C18.3332 11.4477 18.781 11 19.3332 11C19.8855 11 20.3332 11.4477 20.3332 12V16C20.3332 16.5523 19.8855 17 19.3332 17Z"
        />
      </svg>
    );
  }
);
